if (!window.Eurus.loadedScript.has('complimentary-brochure.js')) {
  window.Eurus.loadedScript.add('complimentary-brochure.js');

  (() => {
    const config = window.EurusComplimentaryBrochure || {};
    const productId = config.productId ? String(config.productId) : '';
    const variantId = config.variantId ? String(config.variantId) : '';
    const currentProductId = config.currentProductId ? String(config.currentProductId) : '';
    const excludedProductIds = (config.excludedProductIds || []).map((id) => String(id));
    const routesRoot = window.Shopify?.routes?.root || '/';

    if (!productId && !variantId) return;

    let syncing = false;
    let queued = false;
    let currentSyncPromise = null;
    let checkoutBypass = false;

    const cartHelper = () => {
      try {
        return window.Alpine?.store ? Alpine.store('xCartHelper') : null;
      } catch (error) {
        return null;
      }
    };

    const sectionsToRender = () => {
      const helper = cartHelper();

      if (helper?.getSectionsToRender) {
        return helper.getSectionsToRender().map((section) => section.id);
      }

      return [
        'cart-icon-bubble',
        'mobile-cart-icon-bubble',
        'cart-icon-bubble-mobile-dock',
        'cart-drawer'
      ];
    };

    const renderSections = async (sections) => {
      if (!sections) return;

      const helper = cartHelper();
      if (helper?.reRenderSections) {
        await helper.reRenderSections(sections);
        const count = document.querySelector('#cart-icon-bubble span');
        if (count && helper) {
          helper.currentItemCount = parseInt(count.innerHTML, 10);
        }
      }
    };

    const waitForCart = async () => {
      const helper = cartHelper();
      if (helper?.waitForCartUpdate) {
        await helper.waitForCartUpdate();
      }
    };

    const getCart = async () => {
      const response = await fetch(`${routesRoot}cart.js`, {
        headers: { Accept: 'application/json' }
      });

      return response.json();
    };

    const isBrochure = (item) => {
      return (
        (productId && String(item.product_id) === productId) ||
        (variantId && String(item.variant_id) === variantId) ||
        item.properties?._complimentary_gift === 'The Suffolk Nest Rebrand Brochure'
      );
    };

    const isExcludedProductId = (id) => excludedProductIds.includes(String(id));

    const isExcludedProduct = (item) => {
      return (
        isExcludedProductId(item.product_id) ||
        item.gift_card === true
      );
    };

    const currentProductRequiresGuard = () => currentProductId && !isExcludedProductId(currentProductId);

    const hasCustomerItem = (cart) => {
      return cart.items.some((item) => {
        return !isBrochure(item) && !isExcludedProduct(item) && item.quantity > 0;
      });
    };

    const cartHasItems = () => {
      const mobileBubble = document.getElementById('mobile-cart-icon-bubble');
      const bubbleCount = document.querySelector('#cart-icon-bubble span');
      const count = mobileBubble?.dataset?.value || bubbleCount?.textContent || '0';

      return parseInt(count, 10) > 0;
    };

    const updateBrochureLines = async (updates) => {
      if (!Object.keys(updates).length) return null;

      const response = await fetch(`${routesRoot}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToRender(),
          sections_url: window.location.pathname
        })
      });

      return response.json();
    };

    const addBrochure = async () => {
      if (!config.enabled || !variantId) return null;

      const response = await fetch(`${routesRoot}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: config.properties || {}
            }
          ],
          sections: sectionsToRender(),
          sections_url: window.location.pathname
        })
      });

      const result = await response.json();

      if (!response.ok || result.status === 422) {
        config.enabled = false;
      }

      return result;
    };

    const syncBrochure = async () => {
      if (syncing && currentSyncPromise) {
        queued = true;
        return currentSyncPromise;
      }

      currentSyncPromise = (async () => {
        do {
          queued = false;
          syncing = true;
          await waitForCart();
          window.updatingCart = true;

          try {
            const cart = await getCart();
            const brochureItems = cart.items.filter(isBrochure);
            const updates = {};
            const cartHasEligibleItems = hasCustomerItem(cart);

            setAcceleratedCheckoutGuard(cartHasEligibleItems || currentProductRequiresGuard());

            if (!config.enabled || !cartHasEligibleItems) {
              brochureItems.forEach((item) => {
                updates[item.key] = 0;
              });

              const response = await updateBrochureLines(updates);
              await renderSections(response?.sections);
              continue;
            }

            if (!brochureItems.length) {
              const response = await addBrochure();
              await renderSections(response?.sections);
              continue;
            }

            brochureItems.forEach((item, index) => {
              updates[item.key] = index === 0 ? 1 : 0;
            });

            const response = await updateBrochureLines(updates);
            await renderSections(response?.sections);
          } catch (error) {
            console.error('Complimentary brochure sync failed:', error);
          } finally {
            window.updatingCart = false;
            syncing = false;
          }
        } while (queued);
      })();

      try {
        return await currentSyncPromise;
      } finally {
        currentSyncPromise = null;
      }
    };

    window.EurusSyncComplimentaryBrochure = syncBrochure;

    const setAcceleratedCheckoutGuard = (active) => {
      if (!config.enabled) return;

      document.documentElement.classList.toggle('complimentary-brochure-active', Boolean(active));
    };

    const installAcceleratedCheckoutGuard = () => {
      if (document.getElementById('complimentary-brochure-checkout-style')) return;

      const style = document.createElement('style');
      style.id = 'complimentary-brochure-checkout-style';
      style.textContent = `
        .complimentary-brochure-active .shopify-payment-button,
        .complimentary-brochure-active shopify-accelerated-checkout,
        .complimentary-brochure-active shopify-accelerated-checkout-cart,
        .complimentary-brochure-active #dynamic-checkout-cart,
        .complimentary-brochure-active .dynamic-checkout__content {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
      setAcceleratedCheckoutGuard(currentProductRequiresGuard());
    };

    const isCheckoutTrigger = (target) => {
      return target?.closest?.(
        'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-complimentary-checkout]'
      );
    };

    const isCartCheckoutForm = (form) => {
      if (!form) return false;

      const action = form.getAttribute('action') || '';
      return (
        form.id === 'cart' ||
        form.id === 'CartDrawer-Form' ||
        action.includes('/cart')
      );
    };

    const replayCheckout = (trigger, form) => {
      checkoutBypass = true;

      requestAnimationFrame(() => {
        if (trigger) {
          trigger.click();
        } else if (form?.requestSubmit) {
          form.requestSubmit();
        } else if (form?.submit) {
          form.submit();
        }

        setTimeout(() => {
          checkoutBypass = false;
        }, 1000);
      });
    };

    const guardCheckout = async (event, trigger, form) => {
      if (checkoutBypass || !config.enabled || !cartHasItems()) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const originalPointerEvents = trigger?.style?.pointerEvents || '';
      if (trigger?.style) {
        trigger.style.pointerEvents = 'none';
        trigger.setAttribute('aria-busy', 'true');
      }

      try {
        await syncBrochure();
      } finally {
        if (trigger?.style) {
          trigger.style.pointerEvents = originalPointerEvents;
          trigger.removeAttribute('aria-busy');
        }
      }

      replayCheckout(trigger, form);
    };

    document.addEventListener('click', (event) => {
      const trigger = isCheckoutTrigger(event.target);
      if (!trigger) return;

      const formId = trigger.getAttribute('form');
      const form = trigger.form || (formId ? document.getElementById(formId) : trigger.closest('form'));
      if (!isCartCheckoutForm(form) && !trigger.matches('a[href*="/checkout"]')) return;

      guardCheckout(event, trigger, form);
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!isCartCheckoutForm(form) || checkoutBypass) return;

      const submitter = event.submitter;
      const trigger = isCheckoutTrigger(submitter) || form.querySelector('button[name="checkout"], input[name="checkout"]');
      if (!trigger) return;

      guardCheckout(event, trigger, form);
    }, true);

    document.addEventListener('DOMContentLoaded', () => {
      installAcceleratedCheckoutGuard();
      if (cartHasItems()) {
        setAcceleratedCheckoutGuard(true);
        syncBrochure();
      }
    });
    document.addEventListener('eurus:cart:items-changed', syncBrochure);
    window.addEventListener('pageshow', () => {
      if (cartHasItems()) {
        setAcceleratedCheckoutGuard(true);
        syncBrochure();
      }
    });
  })();
}